// extracted by mini-css-extract-plugin
export default {"innerBlock":"SetupAreaChooser_innerBlock__WJu-q","items":"SetupAreaChooser_items__2LJX0"};